<button
  mat-raised-button
  [disabled]="disabled"
  color="primary"
  type="type"
  (click)="onClickButton($event)"
>
  <ng-content></ng-content> {{ label }}
</button>
